









import { defineComponent } from "@vue/composition-api";
import config from "@/config";
import PageComplaintsView from "./components/PageComplaintsView.vue";

export default defineComponent({
  name: "PageComplaints",
  components: { PageComplaintsView },
  data() {
    let contentUrl = this.$route.query.contentUrl || "";
    if (contentUrl && Array.isArray(contentUrl)) contentUrl = contentUrl[0] || "";
    return {
      values: {
        contentUrl: this.$route.query.contentUrl ?? "",
      } as Record<string, string>,
    };
  },
  computed: {
    supportEmail(): string {
      return config.supportEmail;
    },
    mailToLink(): string {
      let { name, email, contentUrl, complaint } = this.values;
      const body = `Name: ${name}\nEmail: ${email}${contentUrl ? "\nUrl: " + contentUrl : ""}\nComplaint: ${complaint}`;
      return `mailto:${this.supportEmail}?subject=Report&body=${encodeURIComponent(body)}`;
    },
  },
});
